import { __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/theme/themeStructure.ts
import { BorderRadius, BorderWidth, Breakpoint, Color, Duration, Elevation, FontFamily, FontSize, FontWeight, LetterSpacing, LineHeight, Opacity, Sizing, Spacing, Typography, ZIndex } from "@deliveryhero/armor-tokens";
var themeStructure = {
  color: __spreadValues({}, Color),
  borderRadius: __spreadValues({}, BorderRadius),
  borderWidth: __spreadValues({}, BorderWidth),
  breakpoint: __spreadValues({}, Breakpoint),
  duration: __spreadValues({}, Duration),
  elevation: __spreadValues({}, Elevation),
  fontFamily: __spreadValues({}, FontFamily),
  lineHeight: __spreadValues({}, LineHeight),
  letterSpacing: __spreadValues({}, LetterSpacing),
  fontSize: __spreadValues({}, FontSize),
  fontWeight: __spreadValues({}, FontWeight),
  opacity: __spreadValues({}, Opacity),
  sizing: __spreadValues({}, Sizing),
  layoutSpacing: __spreadValues({}, Spacing),
  typography: __spreadValues({}, Typography),
  zIndex: __spreadValues({}, ZIndex)
};
export { themeStructure };